export default "__VITE_ASSET__Ciun_mzk__"